import axios from "axios";
import React, { useEffect, useState } from "react";
import { Table, Button, Form, Modal, Tabs, Tab } from "react-bootstrap";
import { FaEdit, FaEye, FaFileExcel, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

{/* Mapping field names to readable labels */ }



function InvoiceNew() {
  // const API_URL = "http://localhost:8000/student.php";
  const API_URL = "https://learn.fazoacademy.com/php/student.php";

  const navigate = useNavigate();

  const [student, setStudent] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null); // State to store selected student details
  const [courses, setCourses] = useState([]);
  const [mentor, setMentor] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  //search 
  // const [searchQuery, setSearchQuery] = useState("");
  const [searchType, setSearchType] = useState(""); // Store selected search type
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredStudents, setFilteredStudents] = useState([]);

  //date search
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");




  // Fetch student data
  const fetchStudent = async () => {
    try {
      const response = await axios.get(API_URL);
      console.log("Raw API Response:", response.data);

      // Extract only the JSON part (temporary fix)
      const jsonString = response.data.substring(response.data.indexOf("["));
      const parsedData = JSON.parse(jsonString);

      setStudent(Array.isArray(parsedData) ? parsedData : []);
    } catch (error) {
      console.error("Error fetching students:", error);
      setStudent([]);
    }
  };

  useEffect(() => {
  
    fetchStudent();
 
  }, []);

  // Delete student function
  
  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentStudents = (filteredStudents.length ? filteredStudents : student).slice(indexOfFirstItem, indexOfLastItem);


  const handleEdit = (studentData) => {
    navigate("/studentadd", { state: { studentData } });
  };

  // Function to open modal with selected student details
  const handleViewStudent = (student) => {
    setSelectedStudent(student);
    setShowModal(true);
  };



  const handleSearch = () => {
    if (!searchType || (!searchQuery.trim() && searchType !== "dob" &&
      searchType !== "joiningdate" && searchType !== "coursecompleteddate"
      && searchType !== "discontinueddate" && searchType !== "paymentdate")) {
      Swal.fire({
        icon: "warning",
        title: "Search Error",
        text: "Please select a search type and enter a query.",
      });
      return;
    }


    const filteredData = student.filter((item) => {
      if (
        searchType === "dob" ||
        searchType === "joiningdate" ||
        searchType === "coursecompleteddate" ||
        searchType === "discontinueddate" ||
        searchType === "paymentdate"
      ) {
        if (!fromDate || !toDate) {
          Swal.fire({
            icon: "warning",
            title: "Search Error",
            text: "Please select both FROM and TO dates.",
          });
          return false;
        }

        const dateField =
          searchType === "dob" ? item.dob :
            searchType === "joiningdate" ? item.joiningdate :
              searchType === "coursecompleteddate" ? item.coursecompleteddate :
                searchType === "discontinueddate" ? item.discontinueddate :
                  item.paymentdate; // Added discontinueddate and paymentdate

        return dateField >= fromDate && dateField <= toDate;
      }




      else if (searchType === "name") {
        return item.name.toLowerCase().includes(searchQuery.toLowerCase());
      } else if (searchType === "email") {
        return item.email.toLowerCase().includes(searchQuery.toLowerCase());
      } else if (searchType === "phone") {
        return item.phonenumber.includes(searchQuery);
      } else if (searchType === "city") {
        return item.city.toLowerCase().includes(searchQuery.toLowerCase());
      } else if (searchType === "yop") {
        return item.yop.includes(searchQuery);
      } else if (searchType === "gender") {
        return item.gender.toLowerCase() === searchQuery.toLowerCase();
      } else if (searchType === "coursedetails") {
        return item.coursedetails.toLowerCase() === searchQuery.toLowerCase();
      } else if (searchType === "mentor") {
        return item.mentorname.toLowerCase().includes(searchQuery.toLowerCase());
      } else if (searchType === "coursecompleted") {
        return item.coursecompleted.toLowerCase() === searchQuery.toLowerCase();
      } else if (searchType === "certificate") {
        return item.certificate.toLowerCase() === searchQuery.toLowerCase();
      } else if (searchType === "discontinued") {
        return item.discontinued.toLowerCase() === searchQuery.toLowerCase();
      } else if (searchType === "paymentstatus") {
        return item.paymentstatus.toLowerCase() === searchQuery.toLowerCase();
      } else if (searchType === "paymentmode") {
        return item.paymentmode?.toLowerCase() === searchQuery.toLowerCase();
      } else if (searchType === "interviewpreparation") {
        return item.interviewpreparation?.toLowerCase() === searchQuery.toLowerCase();
      }

      return false;
    });

    setFilteredStudents(filteredData);
  };


  const handleReset = () => {
    setFilteredStudents([]);  // Reset filtered list
    setSearchQuery("");
    setSearchType("");
    setFromDate("");
    setToDate("");

  };
  const handleExportToExcel = () => {
    window.open(`${API_URL}?export=excel`, "_blank");
  };
  

  return (
    <>
      <div className="course-container">
        <div className="navigation">
          <a href="#">Invoice</a> / <a href="#">Logout</a>
        </div>

       


        {/* Items per page selection */}


        <div className="row mb-3">
          <div className="col-md-2">
            <Form.Select
              value={itemsPerPage}
              onChange={(e) => setItemsPerPage(Number(e.target.value))}
              className="pagination-select"
            >
              <option value="10">Show 10</option>
              <option value="20">Show 20</option>
              <option value="30">Show 30</option>
            </Form.Select>
          </div>
         </div>


        <Table striped bordered hover className="course-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Student Name</th>
              <th>Email</th>
              <th>Phone Number</th>
              <th>Course Name</th>
              <th>Joining Date</th>
          
            </tr>
          </thead>
          <tbody>
            {currentStudents.length === 0 ? (
              <tr>
                <td colSpan="7" className="text-center">No data found</td>
              </tr>
            ) : (
              currentStudents.map((item, index) => (
                <tr key={item.id}>
                  <td>{indexOfFirstItem + index + 1}</td> {/* Correct serial number */}
                  <td>{item.name}</td>
                  <td>{item.email}</td>
                  <td>{item.phonenumber}</td>
                  <td>{item.coursedetails}</td>
                  <td>{item.joiningdate}</td>
             
                </tr>
              ))
            )}
          </tbody>
        </Table>

        {/* Pagination Controls */}
        <div className="pagination-controls">
          <Button
            variant="secondary"
            onClick={() => setCurrentPage(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </Button>
          <span className="page-number">Page {currentPage}</span>
          <Button
            variant="secondary"
            onClick={() => setCurrentPage(currentPage + 1)}
            disabled={indexOfLastItem >= filteredStudents.length}
          >
            Next
          </Button>
        </div>
      </div>


         </>
  );
}

export default InvoiceNew;